<script setup>
import Alert from '@/components/Atoms/Alert.vue'

defineProps({
  error: String,
})
</script>
<template>
  <Alert type="error" class="flex items-start px-2">
    <div v-if="error == 'The TV Playout quota is exceeded'" class="-mt-1">
      <p class="text-s-m text-500 mb-0">You don’t have enough quota</p>
      <p class="text-s-s text-500 mb-0">Please contact <a class="text-reset text-underline" href="#"
          onclick="Intercom('show')">sales</a> team to get more TV Playout</p>
    </div>
    <div v-else class="-mt-1">
      <p class="text-s-m text-500 mb-0">{{ error }}</p>
    </div>
  </Alert>
</template>